// Stable identity of each seeded Superset dashboard. `id` is our primary key
// (referenced by organisation configurations via embedDashboards.supersetDashboardId)
// and `displayName` is shown to users — both are the same across environments.
export const emhaDrFinderDashboard = {
    id: "e9855de2-a407-409f-846a-30402d79ab64",
    displayName: "eMHA Dr Finder",
};
export const drFinderInternalDashboard = {
    id: "1293cdd2-ab73-4395-9bf3-648c774654fa",
    displayName: "Dr Finder Internal",
};
export const emhaDashboard = {
    id: "3ff28a13-49d3-44c6-b601-9e8a20e62968",
    displayName: "eMHA Dashboard",
};
// superset-developer instance — the Superset local/development target by default.
const supersetDeveloperCoords = {
    [emhaDrFinderDashboard.id]: {
        dashboardId: "16",
        embeddedUuid: "dd416af1-0d36-4196-bf2d-0a3137cc4fd3",
    },
    [drFinderInternalDashboard.id]: {
        dashboardId: "11",
        embeddedUuid: "1c848eb5-1da7-4c4f-a2c3-1b879304c82a",
    },
    [emhaDashboard.id]: {
        dashboardId: "38",
        embeddedUuid: "c97088c1-1cd8-44db-8043-3a061cc560c8",
    },
};
// superset dev instance — used by the deployed `dev` environment.
const supersetDevCoords = {
    [emhaDrFinderDashboard.id]: {
        dashboardId: "46",
        embeddedUuid: "e3ea165f-ce29-4c71-a0c6-2136018a4b5e",
    },
    [drFinderInternalDashboard.id]: {
        dashboardId: "41",
        embeddedUuid: "2ef675d8-448f-4b2c-b7de-19995149e6dc",
    },
    [emhaDashboard.id]: {
        dashboardId: "55",
        embeddedUuid: "0f9776b1-b9c7-4fc8-8659-38d6fa6f6794",
    },
};
// Which Superset coordinates to seed per environment. Environments not listed here
// (e.g. vandp/docker) seed no dashboards. staging/production never run seeding.
//
// A Map, not an object: the environment is arbitrary caller input, and an object
// would resolve an inherited key such as "toString" to a truthy value and seed
// dashboards with no coordinates.
const coordsByEnvironment = new Map([
    ["local", supersetDeveloperCoords],
    ["development", supersetDeveloperCoords],
    ["dev", supersetDevCoords],
]);
const seededDashboards = [
    emhaDrFinderDashboard,
    drFinderInternalDashboard,
    emhaDashboard,
];
// The dashboards to seed for the given environment, with that environment's Superset
// coordinates. Returns an empty list for environments with no configured coordinates.
export function getSeededSupersetDashboards(environment) {
    const coords = coordsByEnvironment.get(environment);
    if (!coords)
        return [];
    return seededDashboards.map((dashboard) => ({
        id: dashboard.id,
        displayName: dashboard.displayName,
        dataGlossaryMarkdown: null,
        containsPid: false,
        ...coords[dashboard.id],
    }));
}
//# sourceMappingURL=supersetDashboards.js.map